export enum PlayerTask {
    LEVEL_NODE_COMPLETE = 'levelNodeComplete',
    EARN_COINS = 'earn_coins',
    SPEND_COINS = 'spend_coins',
    LIVE = 'live',
    KEY = 'key',
    TNT = 'tnt',
    BULLS_EYE = 'bulls_eye',
    SHUFFLE = 'shuffle',
    JOKER = 'joker',
    EXTRA_CARDS = 'extraCards',
    UNLOCK_BACKCARD = 'unlockBackcard',
    CREATE_SHORTCUT = 'createShortcut',
}
